module.exports = __webpack_public_path__ + "static/media/align-right-justify.9dc22a42.svg";